import { useMotionValueEvent, useScroll, UseScrollOptions } from 'motion/react'
import { useRef } from 'react'
import styles from './AutoLoadMoreIndicator.module.css'
import { useScrollAreaContext } from './Layout/ScrollAreaContext'
import PageLoading from './PageLoading'

export interface AutoLoadMoreIndicatorProps extends UseScrollOptions {
	onLoadMore?: () => Promise<void>

	isLoading?: boolean

	threshold?: number
}

function AutoLoadMoreIndicator({
	onLoadMore,
	threshold = 0.8,
	isLoading,
	...props
}: AutoLoadMoreIndicatorProps) {
	const loadingRef = useRef(false)
	const { scrollContainerRef } = useScrollAreaContext()

	// 使用 useScroll 监听滚动
	const { scrollYProgress } = useScroll({
		container: scrollContainerRef,
		...props,
	})

	// 监听滚动位置并触发加载更多
	useMotionValueEvent(scrollYProgress, 'change', (progress: number) => {
		// 检查是否需要加载更多
		if (loadingRef.current || !onLoadMore || progress < threshold) return

		loadingRef.current = true
		onLoadMore().finally(() => {
			loadingRef.current = false
		})
	})

	return isLoading && <PageLoading inline className={styles.container} />
}

export default AutoLoadMoreIndicator
